import React, { useEffect } from 'react';
import CreateBillJobTable from '../components/CreateBillJobTable';
import { reset, resetSingle } from '../billJob.reducer';
import { useAppDispatch, useAppSelector } from '../../../../helpers/redux';
import { useParams } from 'react-router-dom';
import { getSingle } from 'features/worksheet/process/job/job.reducer';
import { RootState } from 'app/store';
import CreateBillJobWithIdForm from '../components/CreateBillJobWithIdForm';
import { isObjectEmpty } from 'helpers/checkEmptiness';

const CreateBillJobWithIdPage = () => {
    const dispatch = useAppDispatch();
    const { id } = useParams();

    const {isLoading, single} = useAppSelector(
        (state: RootState) => state.job
    );

    useEffect(() => {
        dispatch(reset());
        dispatch(resetSingle());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (id && id !== '') {
            dispatch(getSingle(id as string));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    console.log('CreateBillJobPage isLoading: ', isLoading);

    return (
        <div>
            <div className="p-2 md:p-10 bg-white dark:border-gray-700 dark:bg-gray-800 rounded-2xl">
                <div className="flex justify-items-center">
                    <h1 className="text-lg leading-10 grow font-medium truncate mr-5 dark:text-gray-300">
                        Bill Job - {`${single?.number_job} (${single?.number_id})`}
                    </h1>
                </div>
                <div className="mt-3">
                    { (single && !isObjectEmpty(single)) && <CreateBillJobWithIdForm /> }
                    <CreateBillJobTable />
                </div>
            </div>
        </div>
    );
};

export default CreateBillJobWithIdPage;
